import { DefaultLayout } from './DefaultLayout'

export const TexLayout = (page: React.ReactElement): React.ReactElement => {
  return <DefaultLayout zeroPadding>{page} </DefaultLayout>
}
